<script setup>
import SearchUsers from '@/components/SearchUsers.vue'
import HistoryUsersList from '@/components/HistoryUsersList.vue'
import { useSearchUsersStore } from '@/store/modules/search-users.js'

const searchUsersStore = useSearchUsersStore()

function ShowSearchUsers() {
  return !searchUsersStore.IsHistory
}
</script>


<template>
  <div class="tab-container">
    <div class="tab" :class="{'tab-active': ShowSearchUsers()}" @click="searchUsersStore.setIsHistory(!searchUsersStore.IsHistory)">ENCONTRAR PESSOAS</div>
    <div class="tab" :class="{'tab-active': !ShowSearchUsers()}" @click="searchUsersStore.setIsHistory(!searchUsersStore.IsHistory)">LISTAS GUARDADAS</div>
  </div>

  <div class="page-container">
    <SearchUsers v-if="ShowSearchUsers()" :search-users-store="searchUsersStore" />
    <HistoryUsersList v-else-if="!ShowSearchUsers()" :search-users-store="searchUsersStore"/>
  </div>
</template>

<style scoped>

.tab-container {
  display: flex;
  justify-content: space-between;
}

.tab {
  width: 50%;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  background-color: #060714;
  cursor: pointer;
  font-size: 100%;
  opacity: 0.4;
}

.tab-active {
  opacity: 1;
  background-color: transparent;
  border: none;
}

.page-container {
  border-top: 1px solid #06071452;
}

@media screen and (max-width: 700px) {
  .tab-container {
    width: 100%;
  }
}
</style>
